export const pillCartaoAtivo = {
  $border: "#52C41A",
  $color: "#52C41A",
  $bg: "#F6FFED",
};

export const pillCartaoBloqueado = {
  $border: "#FF4D4F",
  $color: "#CF1322",
  $bg: "#FFF1F0",
};
